import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

import { BaseButton } from '../../components/buttons/baseButton';
import { BorderRadius } from '../../tokens/borderRadius';

export const InterestingListWrapper = styled.div`
    width: 100%;
    overflow: hidden;
    margin-top: 40px;
`;
export const InterestingListContainer = styled.div`
    width: 100%;
    overflow: visible;
    margin: 0 auto;

    @media (min-width: ${wideBreakpoints.laptop}) {
        > div > div {
            padding-bottom: 10px;
        }
    }

    @media (max-width: 640px) {
        max-width: 370px;
        margin: 0;
        position: relative;
    }
`;
export const InterestingTitle = styled.div`
    display: flex;
    ${FONTS.H2};
    margin-bottom: 18px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.H3};
        margin-bottom: 15px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H4};
    }
`;

export const InterestingEl = styled.div`
    display: block;
    flex-direction: column;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background: ${COLORS.BgSurface};
    margin-right: 32px;
    width: 100%;

    @media (min-width: ${wideBreakpoints.laptop}) {
        margin-right: ${props => props?.withoutMargin ? 0 : '32px'};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-right: 10px;
    }

    :hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.09);
    };
`;
export const InterestingTop = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    background: ${props => props.back};
    background-repeat: round;
    border-radius: ${BorderRadius.OuterBlockRadius} ${BorderRadius.OuterBlockRadius} 0 0;
    padding: 25px;
    min-height: 167px;
    justify-content: flex-start;
`;
export const InterestingT = styled.div`
    display: flex;
    width: 100%;
    ${FONTS.XS};
    color: ${COLORS.TextWhite};
    margin-bottom: 15px;
`;
export const InterestingDesc = styled.div`
    display: flex;
    white-space: pre-wrap;
    width: 100%;
    ${FONTS.L};
    color: ${COLORS.TextWhite};
    @media (max-width: 1300px) {
        ${FONTS.S};
    }
`;
export const InterestingBottom = styled.div`
    display: flex;
    padding: 30px 25px 30px;
`;

export const InterestingButton = styled(BaseButton)`
    @media (max-width: 1300px) {
        width: 100%;
        text-align: center;
    }
`;
